import { useCallback } from "react";
import { useProjectDataStore } from "stores/projectStore";
import * as Scrivito from "scrivito";
import { getHomepage } from "utils";
import type { IOrderCode } from "interfaces/schemas/orderCode";

interface NavigateToProductProps {
  id: string;
  orderCode: IOrderCode;
  kind: string;
  productName?: string;
}

export const useNavigateToProduct = (): ((
  props: NavigateToProductProps,
) => void) => {
  const homepage = getHomepage();

  const productConfiguratorObj =
    homepage && typeof homepage.get === "function"
      ? homepage.get("productConfiguratorPage")
      : Scrivito.currentPage();

  const projectId = useProjectDataStore((state) => state.projectId);

  const navigateToProduct = useCallback(
    ({ orderCode, id, kind, productName }: NavigateToProductProps): void => {
      if (!productConfiguratorObj) {
        return;
      }

      Scrivito.navigateTo(() => productConfiguratorObj as Scrivito.Link, {
        params: {
          seriesId: String(orderCode?.seriesId),
          productId: id,
          projectId,
          kind,
          productName: productName || null,
        },
      });
    },
    [projectId, productConfiguratorObj],
  );

  return navigateToProduct;
};
